var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3917 14.0249L15.7167 16.6582C15.8 17.3498 15.0584 17.8331 14.4667 17.4748L10.975 15.3998C10.5917 15.3998 10.2167 15.3748 9.85004 15.3248C10.4667 14.5998 10.8334 13.6832 10.8334 12.6915C10.8334 10.3248 8.78337 8.40819 6.25004 8.40819C5.28337 8.40819 4.39171 8.68317 3.65004 9.1665C3.62504 8.95817 3.6167 8.74983 3.6167 8.53316C3.6167 4.7415 6.90837 1.6665 10.975 1.6665C15.0417 1.6665 18.3334 4.7415 18.3334 8.53316C18.3334 10.7832 17.175 12.7749 15.3917 14.0249Z",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 12.6915C10.8334 13.6832 10.4668 14.5999 9.85009 15.3249C9.02509 16.3249 7.71675 16.9665 6.25008 16.9665L4.07508 18.2582C3.70841 18.4832 3.24175 18.1748 3.29175 17.7498L3.50008 16.1082C2.38341 15.3332 1.66675 14.0915 1.66675 12.6915C1.66675 11.2248 2.45009 9.93318 3.65009 9.16651C4.39175 8.68318 5.28341 8.4082 6.25008 8.4082C8.78342 8.4082 10.8334 10.3248 10.8334 12.6915Z",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages2);
export default __webpack_public_path__ + "static/media/messages-2.488d9e22eb1d6e655ad65b26e3c172be.svg";
export { ForwardRef as ReactComponent };